import "./App.css";
import { RoutesManager } from "./config/RoutesManager";

function App() {
  return (
    <div className="App">
      <RoutesManager></RoutesManager>
    </div>
  );
}

export default App;
